import { FC } from "react";
import { useDispatch } from "react-redux";

import { UserSocialSecurityForm } from "Bands/components";
import { createUserSocialSecurityForm, dispatchGetUserSocialSecurityForms } from "Bands/state";
import { IUserSocialSecurityFormPatchData, USER_ACTIONS } from "Bands/types";
import { copy } from "shared/assets";
import { IFormButtons } from "shared/types";
import { UserEntityModal } from "Bands/containers";
import { UserForm } from "shared/assets/icons";

const { userSocialSecurityForm: formCopy } = copy;

interface Props {
  handleClose: () => void;
}

export const CreateUserSocialSecurityFormModal: FC<Props> = ({ handleClose }) => {
  const dispatch = useDispatch();

  const buttons: IFormButtons = {
    primary: {
      children: formCopy.buttons.create,
    },
    secondary: {
      onClick: handleClose,
    },
  };

  const handleSubmit = (data: IUserSocialSecurityFormPatchData) => {
    dispatch(createUserSocialSecurityForm(data));
  };

  const handleSuccess = () => {
    dispatchGetUserSocialSecurityForms(dispatch);
  };

  return (
    <UserEntityModal
      title={formCopy.create.title}
      icon={UserForm}
      action={USER_ACTIONS.createUserSocialSecurityForm}
      buttons={buttons}
      successMessage={formCopy.messages.created}
      Component={UserSocialSecurityForm}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      handleSuccess={handleSuccess}
    />
  );
};
